import { CAMERA_PRESENTER } from '@shoflo/polymer/constants/SourceItems';
import { takePresenterLive } from '@shoflo/studio-redux/actions';
import { MAX_CAMERA_LIMIT } from 'constants/index';
import setProgram from './setProgram';
import { StudioLogger } from '@studio/logger/StudioLogger';

import { showNotification } from '../index';
import toggleVideoActive from './toggleVideoActive';

const logger = new StudioLogger('presenter-live-toggle');

function togglePresenterLive() {
  return (dispatch, getState) => {
    const {
      meeting: { attendeeResponse },
      user,
      program,
      broadcastSources,
      attendeeCameraStatus
    } = getState();
    const { AttendeeId } = attendeeResponse.Attendee;
    const presenterIsLive = program.layers.some(
      layer => layer.source.value === AttendeeId
    );
    const source = broadcastSources.sources.find(s => s.value === AttendeeId);
    const cameraPresenterCount = program.layers.filter(
      layer => layer.source.type === CAMERA_PRESENTER
    );

    if (!presenterIsLive && cameraPresenterCount.length >= MAX_CAMERA_LIMIT) {
      // we will not change the scene since we are on the limit but only display notification to inform the user that the limit is attained.
      dispatch(
        showNotification(
          `You're at the max of ${MAX_CAMERA_LIMIT} sources available at a time in program.`,
          { timeout: 3500, type: 'alert' }
        )
      );
    } else {
      const title = presenterIsLive
        ? `Presenter with id ${user?._id} toggle live state. Previously presenter was live.`
        : `Presenter with id ${user?._id} toggle live state. Previously presenter was not live.`;

      logger.info(title, {});

      const attendeeVideoActive = attendeeCameraStatus[AttendeeId] ?? true; // Default to true (camera ON) to avoid unnecessarily toggling video when status is unknown.
      if (!attendeeVideoActive && !presenterIsLive)
        dispatch(toggleVideoActive());
      dispatch(takePresenterLive(source, {}, setProgram));
    }
  };
}

export default togglePresenterLive;
